import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { FolderViewWrapper } from "../../../src/taskpane/components/helpers/folderViewWrapper";
import { ComponentTypes } from "../../../src/taskpane/config/config";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { RenameA20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/RenameA20Regular";

export function useMenuItem_Rename(selectedItems: any[], waitFor: boolean, setShowRenameDialog: (showRenameDialog: boolean) => void) {
    const languageStrings = React.useContext(LanguageContext);

    const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
    const siteInfo = useSelector((state: RootState) => state.tenantInfo.sites);
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
    const tenantDisableFileRename = useSelector((state: RootState) => state.tenantInfo?.disableFileRename);

    const menuItem_Rename = React.useMemo(() => {
        if (!tenantDisableFileRename && selectedItems?.length === 1 && selectedItems[0]?.EffectiveBasePermissions?.canDeleteListItem && currentDirectory.type !== ComponentTypes.SharePointList) {
            var folderViewWrapper = new FolderViewWrapper(siteInfo, currentDirectory);
            const canViewFolder = folderViewWrapper.canViewFolder();

            if (canViewFolder || selectedItems[0].FSObjType === '0') {
                return {
                    key: "rename",
                    disabled: waitFor === true || isBusySaving === true,
                    text: `${languageStrings.RenameOnly}`,
                    // iconProps: { iconName: "Rename" },
                    iconProps: {},
                    onRenderIcon: () => <RenameA20Regular className={menuItemIconStyles} />,
                    onClick: () => {
                        setShowRenameDialog(true);
                    }
                } as IContextualMenuItem;
            }
        }
        return null;
    }, [selectedItems, waitFor, siteInfo, currentDirectory, tenantDisableFileRename, isBusySaving, languageStrings, setShowRenameDialog]);

    return {
        menuItem_Rename
    }

}
